import { Typography } from 'antd';

import { LeadModel } from '@/typings/models/Lead';

const CustomerState = ({lead}: {lead: LeadModel, isTable?: boolean}) => {
  const state = lead?.customer?.state;
  const label = typeof state === 'object' ? state?.value || state?.label : state;
  return <Typography.Text>{label}</Typography.Text>;
}

export default CustomerState
